import { Box, Chip, Typography, Skeleton } from '@mui/material';

interface PeriodBadgeProps {
  weekLabel: string | null;
  dateRange: string | null;
  isLoading: boolean;
}

export function PeriodBadge({
  weekLabel,
  dateRange,
  isLoading,
}: PeriodBadgeProps) {
  if (isLoading) {
    return (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          gap: 0.5,
        }}
      >
        <Skeleton width={120} height={32} />
        <Skeleton width={100} height={20} />
      </Box>
    );
  }

  if (!weekLabel) return null;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 0.5,
      }}
    >
      <Chip
        label={weekLabel}
        variant="outlined"
        size="small"
        sx={{
          borderColor: 'success.main',
          color: 'success.main',
          fontWeight: 600,
        }}
      />
      {dateRange && (
        <Typography variant="caption" color="text.secondary">
          {dateRange}
        </Typography>
      )}
    </Box>
  );
}
